import { useContext } from 'react';

import { Context } from './context';

/**
 * Returns the modal-manager container element (not a ref). Pass it straight to
 * `createPortal` or `portalProps.target` — never add `.current`.
 */
export const useModalManagerPortal = (): HTMLDivElement | undefined => {
  const { modalManagerRef } = useContext(Context);

  return modalManagerRef;
};
